import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class AmpelService {
  public http = inject(HttpClient);

  public getAmpelInfo(id: number): Observable<any> {
    const overwriteId = 2311;

    return this.http
      .get(environment.url.bff + '/trafficlights/' + overwriteId)
      .pipe(
        map(data => {
          // const data = response.json();
          return data;
        })
      );
  }
}
